import ExcelJs from 'exceljs';

import { MessageDto } from '../dto';
import { UserType, USER_TEXT } from '../constants';

const getDisplayName = (from: MessageDto['from']): string => {
  if (from.name) return from.name;
  return from.type === UserType.CLIENT ? '고객' : '매니저';
};

const sanitizeFileName = (str: string): string => {
  return str
    .replace(/[\s]+/g, '') // 공백 제거
    .replace(/[\\/:*?"<>|[\]{}()!@#$%^&+=~`';,]/g, '') // 특수문자 제거
    .substring(0, 50);
};

export const generateChatExcel = async (
  messages: MessageDto[],
  groupTitle: string,
  clientName?: string
) => {
  const workbook = new ExcelJs.Workbook();
  const worksheet = workbook.addWorksheet('대화내용');

  // 헤더 정보
  worksheet.addRow(['대화 제목:', groupTitle]);
  if (clientName) {
    worksheet.addRow(['고객사:', clientName]);
  }
  worksheet.addRow(['다운로드 일시:', new Date().toLocaleString('ko-KR')]);
  worksheet.addRow([]);

  // 테이블 헤더 행 번호 계산
  const headerRowNum = clientName ? 5 : 4;

  // 테이블 헤더
  const headers = ['번호', '작성자', '유형', '내용', '첨부파일', '작성일시'];
  worksheet.addRow(headers);

  // 컬럼 너비 설정
  const widths = [10, 20, 15, 60, 60, 25];
  widths.forEach((width, index) => {
    const columnLetter = String.fromCharCode(65 + index);
    worksheet.getColumn(columnLetter).width = width;
  });

  // 메시지 데이터 (시간순 정렬)
  const sortedMessages = [...messages].sort(
    (a, b) => new Date(a.at).getTime() - new Date(b.at).getTime()
  );

  sortedMessages.forEach((message, index) => {
    const fileInfo = message.files
      .map((file) => `${file.name}\n${file.path}`)
      .join('\n\n');
    const dateStr = new Date(message.at).toLocaleString('ko-KR');

    worksheet.addRow([
      index + 1,
      getDisplayName(message.from),
      USER_TEXT[message.from.type] || message.from.type,
      message.content,
      fileInfo || '-',
      dateStr,
    ]);
  });

  // 헤더 행 스타일
  const headerRow = worksheet.getRow(headerRowNum);
  headerRow.font = { bold: true };
  headerRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFECEFFE' },
  };

  // 전체 행 스타일
  worksheet.eachRow((row, rowNumber) => {
    row.alignment = { vertical: 'middle', wrapText: true };
    if (rowNumber >= headerRowNum) {
      row.height = 25;
    }
  });

  // 파일명 생성: 문의답변_{대화제목}_{다운로드날짜}
  const safeTitle = sanitizeFileName(groupTitle);
  const dateStr = new Date().toISOString().split('T')[0];
  const fileName = `문의답변_${safeTitle}_${dateStr}.xlsx`;

  // 파일 다운로드
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
};
